/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./StudentSelector.vue?vue&type=template&id=56e4bfeb&scoped=true&"
import script from "./StudentSelector.vue?vue&type=script&lang=js&"
export * from "./StudentSelector.vue?vue&type=script&lang=js&"
import style0 from "./StudentSelector.vue?vue&type=style&index=0&id=56e4bfeb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e4bfeb",
  null
  
)

export default component.exports